/* Becker Candle Co. — House C motion: headline reveals, hero parallax, the candle-glow breath.
   Everything is transform/opacity, everything stops under prefers-reduced-motion, and phones get stills. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarse = window.matchMedia('(pointer: coarse)').matches;
  var lowMem = navigator.deviceMemory && navigator.deviceMemory < 4;

  function ready(fn) { document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn(); }

  ready(function () {
    /* 1. Reveals: the first display heading of each section, nothing else. */
    if (!reduce && 'IntersectionObserver' in window) {
      var heads = [];
      document.querySelectorAll('.shopify-section').forEach(function (sec) {
        var h = sec.querySelector('h1, h2');
        if (h && !h.closest('header, #header-group, .cart-drawer, [class*="drawer"]')) heads.push(h);
      });
      heads.forEach(function (h) { h.classList.add('bk-reveal'); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('bk-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.2 });
      heads.forEach(function (h) { io.observe(h); });
      /* safety net: nothing stays invisible if the observer never fires (reader modes, print, screenshot tools) */
      setTimeout(function () { heads.forEach(function (h) { h.classList.add('bk-in'); }); }, 2500);
      /* anything already in view reveals on the next frame so nothing sits invisible */
      requestAnimationFrame(function () { heads.forEach(function (h) { var r = h.getBoundingClientRect(); if (r.top < innerHeight && r.bottom > 0) h.classList.add('bk-in'); }); });
    }

    /* 2. Hero parallax: desktop, fine pointer, enough memory. */
    var heroMedia = document.querySelector('.hero__media');
    if (heroMedia && !reduce && !coarse && !lowMem) {
      var ticking = false;
      function onScroll() {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          var y = Math.min(window.scrollY, window.innerHeight);
          heroMedia.style.setProperty('--bk-y', (y * 0.12).toFixed(1) + 'px');
          ticking = false;
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* 3. The one ambient element: a soft glow breathing over the story band's photograph. */
    var story = document.querySelector('[id$="__story"], [id$="__pouring"]');
    if (story) {
      var img = story.querySelector('img');
      var host = img && (img.closest('figure') || img.parentElement);
      if (host && !host.querySelector('.bk-glow')) {
        host.classList.add('bk-glow-host');
        var g = document.createElement('span'); g.className = 'bk-glow'; g.setAttribute('aria-hidden', 'true');
        host.appendChild(g);
      }
    }
  });

  /* 4. Cart rewards: keep the free candle in step with the cart total (Jesse 10/10). */
  var cfgEl = document.getElementById('bk-rewards-config');
  if (cfgEl) {
    var parts = cfgEl.textContent.trim().split('|');
    var giftVariant = (parts[0] || '').replace(/"/g, ''), giftAt = parseInt(parts[2], 10) || 7500, enabled = parts[3] === '1';
    /* the scent a shopper picked comes back with the free candle if the cart dips under the line and climbs back (Jesse 10/18) */
    var giftChoices = (parts[4] || '').split(',').filter(Boolean);
    /* any line of the free candle counts as the free candle, however it got into the cart (Jesse 10/29: "when they
       reach $70, they get the free candle, period."); under $70 it comes out, one per order */
    function isGift(it) { return !!((it.properties && it.properties._gift) || (it.variant_id && (giftChoices.indexOf(String(it.variant_id)) !== -1 || String(it.variant_id) === giftVariant))); }
    function giftToAdd() {
      var kept = null; try { kept = localStorage.getItem('bk_gift_scent'); } catch (e) {}
      return kept && giftChoices.indexOf(kept) !== -1 ? kept : giftVariant;
    }
    var busy = false, lastStage = null;
    if (giftVariant && giftVariant !== 'null' && enabled) {
      function sectionIds() {
        return Array.prototype.map.call(document.querySelectorAll('cart-items-component[data-section-id]'), function (el) { return el.dataset.sectionId; }).filter(Boolean).join(',');
      }
      function post(url, body) {
        return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
      }
      function announce(cart, resp) {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'becker-gift', data: { source: 'becker-gift', sections: resp.sections || {}, itemCount: cart.item_count } } }));
        setTimeout(celebrate, 80);
      }
      function celebrate() {
        var bar = document.querySelector('[data-bk-rewards]'); if (!bar) return;
        var stage = parseInt(bar.dataset.stage, 10);
        if (stage === 2 && lastStage !== 2 && lastStage !== null) { bar.classList.add('bk-rewards--won'); setTimeout(function () { bar.classList.remove('bk-rewards--won'); }, 3300); }
        lastStage = stage;
      }
      /* while the free candle is being added or taken out, the cart's checkout buttons wait; a checkout pressed meanwhile
         goes on by itself once the cart is right (Jesse 10/19: "we need it to all work properly") */
      var again = false, wantCheckout = false, syncTimer = 0;
      function syncing(on) {
        clearTimeout(syncTimer);
        document.documentElement.classList.toggle('bk-cart-syncing', !!on);
        /* never hold the checkout longer than 4 seconds, even if a cart request stalls */
        if (on) { syncTimer = setTimeout(function () { syncing(false); }, 4000); return; }
        if (wantCheckout) { wantCheckout = false; window.location.href = '/checkout'; }
      }
      document.addEventListener('click', function (e) {
        if (!document.documentElement.classList.contains('bk-cart-syncing')) return;
        var b = e.target.closest && e.target.closest('#checkout, .cart__checkout-button');
        if (b) { e.preventDefault(); e.stopPropagation(); wantCheckout = true; }
      }, true);
      document.addEventListener('submit', function (e) {
        if (!document.documentElement.classList.contains('bk-cart-syncing')) return;
        if (e.target && e.target.id === 'cart-form') { e.preventDefault(); wantCheckout = true; }
      }, true);
      function reconcile(fromUser) {
        if (busy) { again = true; return; } busy = true; syncing(true);
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          var total = 0, giftLine = null;
          cart.items.forEach(function (it) { if (isGift(it)) giftLine = it; else if (!it.gift_card && it.product_type !== 'Candle Subscription') total += it.final_line_price; });
          var ids = sectionIds();
          var gifts = cart.items.filter(isGift);
          if (gifts.length > 1 || (giftLine && giftLine.quantity > 1)) {
            /* the free candle is one per order: drop extra gift lines, hold the kept one at 1 */
            var fix = {}; gifts.forEach(function (g, i) { fix[g.key] = i === 0 ? 1 : 0; });
            return post('/cart/update.js', { updates: fix, sections: ids }).then(function (resp) {
              return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c2) { announce(c2, resp); });
            });
          }
          if (total >= giftAt && !giftLine) {
            return post('/cart/add.js', { items: [{ id: giftToAdd(), quantity: 1, properties: { _gift: 'true' } }], sections: ids }).then(function (resp) {
              return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c2) { announce(c2, resp); });
            });
          }
          if (total < giftAt && giftLine) {
            return post('/cart/change.js', { id: giftLine.key, quantity: 0, sections: ids }).then(function (resp) {
              return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c2) { announce(c2, resp); });
            });
          }
          if (fromUser) celebrate();
        }).catch(function () {}).then(function () {
          busy = false;
          if (again) { again = false; reconcile(true); return; }
          syncing(false);
        });
      }
      /* the shopper picks (or changes) the scent of the free candle, from the bar's buttons or the line's dropdown */
      function swapGift(want) {
        if (busy || !want) return; busy = true; syncing(true);
        try { localStorage.setItem('bk_gift_scent', want); } catch (e2) {}
        var ctrls = document.querySelectorAll('[data-bk-gift-pick], [data-bk-gift-select]');
        ctrls.forEach(function (b) { b.disabled = true; });
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          var line = null; cart.items.forEach(function (it) { if (isGift(it)) line = it; });
          var ids = sectionIds();
          if (line && String(line.variant_id) === String(want)) { return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c2) { announce(c2, {}); }); }
          var drop = line ? post('/cart/change.js', { id: line.key, quantity: 0 }) : Promise.resolve();
          return drop.then(function () {
            return post('/cart/add.js', { items: [{ id: want, quantity: 1, properties: { _gift: 'true' } }], sections: ids });
          }).then(function (resp) {
            return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c2) { announce(c2, resp); });
          });
        }).catch(function () {}).then(function () { busy = false; syncing(false); document.querySelectorAll('[data-bk-gift-pick], [data-bk-gift-select]').forEach(function (b) { b.disabled = false; }); });
      }
      document.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-bk-gift-pick]');
        if (!btn || btn.getAttribute('aria-pressed') === 'true') return;
        e.preventDefault(); swapGift(btn.getAttribute('data-bk-gift-pick'));
      });
      document.addEventListener('change', function (e) {
        var sel = e.target.closest && e.target.closest('[data-bk-gift-select]');
        if (sel) swapGift(sel.value);
      });
      document.addEventListener('cart:update', function (e) {
        if (e.detail && e.detail.data && e.detail.data.source === 'becker-gift') return;
        syncing(true);
        setTimeout(function () { reconcile(true); }, 60);
      });
      /* 4b. Shop Pay, PayPal and Google Pay on a candle page skip the cart, so they never carry the free candle: while this
         page's own order would reach it, they step aside and the shopper is sent to Add to cart, where the scent is picked */
      var xcNote = 'A free 5.5 oz candle comes with this order, so add to cart to pick its scent.', xcFrame = 0;
      /* the half-off sale's dates (store time): while it is on, a second candle of the same kind is half off at checkout */
      var saleWins = (parts[5] || '').split(',').map(function (w) { var p = w.trim().split('..'); return p.length === 2 ? [p[0].replace(/-/g, ''), p[1].replace(/-/g, '')] : null; }).filter(Boolean);
      function saleOn() {
        var d; try { d = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()).replace(/-/g, ''); } catch (e) { return false; }
        return saleWins.some(function (w) { return d >= w[0] && d <= w[1]; });
      }
      function gateExpress() {
        xcFrame = 0;
        document.querySelectorAll('[data-bk-xc-prices]').forEach(function (blk) {
          var form = blk.closest('form'); if (!form) return;
          var prices = {};
          blk.getAttribute('data-bk-xc-prices').split(',').forEach(function (pair) { var kv = pair.split(':'); if (kv.length === 2) prices[kv[0]] = parseInt(kv[1], 10) || 0; });
          var idIn = form.querySelector('input[name="id"]'), qtyIn = form.querySelector('input[name="quantity"]');
          var qty = qtyIn ? Math.max(1, parseInt(qtyIn.value, 10) || 1) : 1;
          var unit = idIn ? (prices[idIn.value] || 0) : 0, sum = unit * qty;
          if (qty >= 2 && saleOn()) sum -= Math.round(unit / 2);   /* one candle half off, one per order */
          var over = !!idIn && sum >= giftAt;
          blk.classList.toggle('bk-xc-off', over);
          var note = blk.nextElementSibling && blk.nextElementSibling.classList.contains('bk-xc-note') ? blk.nextElementSibling : null;
          if (!note) { note = document.createElement('p'); note.className = 'bk-xc-note'; note.setAttribute('role', 'status'); note.hidden = true; blk.insertAdjacentElement('afterend', note); }
          if (over !== !note.hidden) { note.hidden = !over; note.textContent = over ? xcNote : ''; }
        });
      }
      function gateSoon() { if (!xcFrame) xcFrame = requestAnimationFrame(gateExpress); }
      ['input', 'change', 'click', 'quantity-selector:update', 'variant:update'].forEach(function (t) { document.addEventListener(t, gateSoon, true); });
      new MutationObserver(gateSoon).observe(document.body, { childList: true, subtree: true });
      gateExpress();
      var first = document.querySelector('[data-bk-rewards]'); if (first) lastStage = parseInt(first.dataset.stage, 10);
      reconcile(false);
    }
  }

  /* 5. Image bands (story, About, contact) reveal from the center as they arrive. */
  if (!reduce && 'IntersectionObserver' in window) {
    var bands = document.querySelectorAll('.media-with-content');
    bands.forEach(function (bnd) { bnd.classList.add('bk-band'); });
    var bio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('bk-band--in'); bio.unobserve(e.target); } });
    }, { threshold: 0.18 });
    bands.forEach(function (bnd) { bio.observe(bnd); });
    setTimeout(function () { bands.forEach(function (bnd) { bnd.classList.add('bk-band--in'); }); }, 4000);
  }

  /* 6. Anything marked data-bk-reveal gets .bk-in as it arrives (the story page). */
  var marked = document.querySelectorAll('[data-bk-reveal]');
  if (marked.length) {
    if (reduce || !('IntersectionObserver' in window)) { marked.forEach(function (el) { el.classList.add('bk-in'); }); }
    else {
      var mio = new IntersectionObserver(function (entries) { entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('bk-in'); mio.unobserve(e.target); } }); }, { threshold: 0.15 });
      marked.forEach(function (el) { mio.observe(el); });
      requestAnimationFrame(function () { marked.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < innerHeight * 0.9 && r.bottom > 0) el.classList.add('bk-in'); }); });
      setTimeout(function () { marked.forEach(function (el) { el.classList.add('bk-in'); }); }, 5000);
    }
  }
})();

/* ---- Emily's look (2026-10-11): the note settles and its bow ties itself; snapshots and the collection label arrive. ---- */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els = [].slice.call(document.querySelectorAll('[data-bk-arrive]'));
  if (!els.length) return;
  els.forEach(function (el) {
    var lines = [].slice.call(el.querySelectorAll('[data-bk-line]'));
    if (lines.length > 1) {                                   // one line a day, by the visitor's own calendar
      var now = new Date(), day = Math.floor((Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())) / 864e5) % lines.length;
      lines.forEach(function (l, i) { l.hidden = i !== day; });
    }
    [].slice.call(el.querySelectorAll('.bk-made__step')).forEach(function (s, i) { s.style.setProperty('--bk-i', i); });
    [].slice.call(el.querySelectorAll('.bk-bow path')).forEach(function (p, i) { p.setAttribute('pathLength', '1'); p.style.setProperty('--bk-d', (600 + i * 170) + 'ms'); });
  });
  if (reduce || !('IntersectionObserver' in window)) return;
  els.forEach(function (el) { el.setAttribute('data-bk-arm', ''); });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('bk-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
  els.forEach(function (el) { io.observe(el); });
  setTimeout(function () { els.forEach(function (el) { el.classList.add('bk-in'); }); }, 6000);   // never leave anything hidden
})();
